import { Fetcher } from '../../api/impl/utils/Fetcher';

export async function sendSlackNotification(opts: {
    fetcher: Fetcher;
    authToken: string;
    channelId: string;
    text: string;
}): Promise<void> {
    const payload = { channel: opts.channelId, text: opts.text };

    const res = await opts.fetcher.fetch({
        body: JSON.stringify(payload),
        headers: {
            Authorization: `Bearer ${opts.authToken}`,
            'Content-Type': 'application/json; charset=utf-8',
        },
        method: 'POST',
        url: 'https://slack.com/api/chat.postMessage',
    });

    if (res.statusCode !== 200) {
        throw Error(`Slack message API request failed: ${res.statusCode} ${res.body}`);
    }

    const resBody = JSON.parse(res.body);

    if (resBody.error) {
        throw new Error(`Slack message API error response: ${res.body}`);
    }
}
